import type { ReactNode } from 'react';
import { useMemo } from 'react';
import type { z } from 'zod';

import { FormSchemaContext } from './FormSchemaContext';

interface FormSchemaProviderProps {
  schema: z.ZodType;
  children: ReactNode;
}

function FormSchemaProvider({ schema, children }: FormSchemaProviderProps) {
  const value = useMemo(() => ({ schema }), [schema]);

  return (
    <FormSchemaContext.Provider value={value}>
      {children}
    </FormSchemaContext.Provider>
  );
}

FormSchemaProvider.displayName = 'FormSchemaProvider';

export { FormSchemaProvider };
